import { gql } from '@apollo/client'
import { PageInfoLiteFragment } from '@src/graphql/fragment/pageInfo'

export const BattleDemoRankFragment = gql`
  fragment BattleDemoRank on DungeonLeaderboardRecord {
    score
    planet {
      classIcon
      id
      metaKey
    }
    rank
    user {
      name
      tag
      walletAddress
    }
  }
`

export const BattleDemoLeaderboardRecordFragment = gql`
  fragment LeaderboardRecordCommon on DungeonLeaderboardInfo {
    globalRecords {
      ...BattleDemoRank
    }
    pageInfo {
      ...PageInfoLite
    }
  }
  ${BattleDemoRankFragment}
  ${PageInfoLiteFragment}
`

export const BattleDemoMyLeaderboardRecordFragment = gql`
  fragment MyLeaderboardRecordCommon on MyDungeonLeaderboardInfo {
    globalRecords {
      ...BattleDemoRank
    }
    pageInfo {
      ...PageInfoLite
    }
  }
  ${BattleDemoRankFragment}
  ${PageInfoLiteFragment}
`

export const BattleDemoLeaderboardFragment = gql`
  fragment LeaderboardCommon on CommonDungeonLeaderboard {
    category
    leaderboardKey
    period {
      start
      end
    }
    rewardInfo
  }
`

export const BattleDemoSeasonRewardFragment = gql`
  fragment SeaonalReward on GamePvpSeasonalReward {
    fromRank
    rewards {
      metaKey
      qty
    }
    toRank
  }
`
